import PropTypes from "prop-types"
import React, { useEffect, useState, useRef } from "react"
import { useDispatch } from "react-redux"
import { Modal, ModalBody } from "reactstrap"
import moment from "moment"

import Flatpickr from "react-flatpickr"
import "flatpickr/dist/themes/material_blue.css"
import { Spanish } from "flatpickr/dist/l10n/es.js"
import classnames from "classnames"
import {
  Button,
  Card,
  CardBody,
  CardText,
  CardTitle,
  Col,
  Container,
  Form,
  FormFeedback,
  Input,
  InputGroup,
  Label,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap"

import { useFormik } from "formik"
import * as Yup from "yup"

import CargosListado from "./CargosListado"
import { useCajaoUltimoCargo } from "store/selectors"
import { getCajaUltimoCargo as onGetCajaUltimoCargo } from "store/actions"

const CargosInsertColegiatura = ({
  idAlumno,
  dataServicios,
  tab,
  customActiveTab,
  isLoading,
}) => {
  //
  Date.prototype.addDays = function (days) {
    var date = new Date(this.valueOf())
    date.setDate(date.getDate() + days)
    return date
  }
  //

  const flatpickrRef = useRef(null)
  const optionsFlatpickr = {
    locale: Spanish,
    altInput: true,
    dateFormat: "d-m-y",
  }
  //
  //
  const dispatch = useDispatch()
  const ocargo = useCajaoUltimoCargo()

  const [pick_date, setPickDate] = useState(new Date().addDays(9))
  const [oUltimoCargo, setoUltimoCargo] = useState()
  const [sFechaExpiracion, setsFechaExpiracion] = useState("2000-10-01")
  const [sCantidadaCargar, setCantidadaCargar] = useState("0")

  //
  //Horizontal form
  const horizontalformik = useFormik({
    initialValues: {
      firstname: "",
      email: "",
      password: "",
      check: "",
    },
    validationSchema: Yup.object({
      firstname: Yup.string().required("This field is required"),
      email: Yup.string()
        .email()
        .matches(/^(?!.*@[^,]*,)/)
        .required("Please Enter Your Email"),
      password: Yup.string()
        .min(6, "Password must be at least 6 characters")
        .matches(RegExp("(.*[a-z].*)"), "At least lowercase letter")
        .matches(RegExp("(.*[A-Z].*)"), "At least uppercase letter")
        .matches(RegExp("(.*[0-9].*)"), "At least one number")
        .required("This field is required"),
      check: Yup.string().required("This field is required"),
    }),

    onSubmit: values => {
      // console.log("value", values.password);
    },
  })

  useEffect(() => {
    setPickDate(new Date().addDays(9))
  }, [])

  useEffect(() => {
    console.log("Cole: ", tab, "::", customActiveTab)
    if (idAlumno > 0 && tab == customActiveTab) {
      console.log(
        "Cole Entró! id:Alumno:",
        idAlumno,
        "::",
        tab,
        "::",
        customActiveTab
      )
      dispatch(
        onGetCajaUltimoCargo({
          nombreSolicitud: "getultimocargoxidgruposervicios",
          idAlumno: idAlumno,
          idGrupoServicios: 1,
        })
      )
    }
  }, [useDispatch, idAlumno, customActiveTab])

  useEffect(() => {
    if (ocargo !== undefined && tab == customActiveTab) {
      console.log("ocargo:", ocargo)
      setoUltimoCargo(ocargo)
      const item = dataServicios.find(oservicio => {
        return oservicio.id_Servicio == ocargo.id_Servicio
      })
      console.log("item: ", item)
      setCantidadaCargar(item?.Cantidad ? item.Cantidad : 9)
      if (ocargo.Fecha_Cargo) {
        const cadena =
          moment(ocargo.Fecha_Cargo).format("DD MMM, YYYY") +
          " - $" +
          ocargo.Cantidad
        console.log("cadena:", cadena)
        setsFechaExpiracion(cadena)
      }
    }
  }, [useDispatch, ocargo, customActiveTab])

  // useEffect(() => {

  // }, [isLoading])

  // useEffect(() => {
  //   setPickDate(new Date().addDays(9))
  // }, [])

  return (
    <React.Fragment>
      <Card>
        <CardBody>
          <Form onSubmit={horizontalformik.handleSubmit}>
            <Row className="mb-4">
              <Label
                htmlFor="horizontal-firstname-Input"
                className="col-sm-3 col-form-label"
              >
                Expira
              </Label>
              <Col sm={9}>
                {/* <Input
                            name="firstname"
                            type="text"
                            className="form-control"
                            id="horizontal-firstname-Input"
                            placeholder="Enter Your"
                            value={horizontalformik.values.firstname}
                            onChange={horizontalformik.handleChange}
                            onBlur={horizontalformik.handleBlur}
                            invalid={
                              horizontalformik.touched.firstname &&
                              horizontalformik.errors.firstname
                                ? true
                                : false
                            }
                          /> */}
                <InputGroup>
                  <Flatpickr
                    ref={flatpickrRef}
                    id="Fecha_Expiracion"
                    value={Date.parse(pick_date)}
                    className="form-control d-block"
                    placeholder="Fecha Expiracion"
                    options={optionsFlatpickr}
                  />
                </InputGroup>
                {horizontalformik.errors.firstname &&
                horizontalformik.touched.firstname ? (
                  <FormFeedback type="invalid">
                    {horizontalformik.errors.firstname}
                  </FormFeedback>
                ) : null}
              </Col>
            </Row>
            <Row className="mb-4">
              <Label
                htmlFor="horizontal-email-Input"
                className="col-sm-3 col-form-label"
              >
                Cantidad
              </Label>
              <Col sm={9}>
                {isLoading ? (
                  <>sdfgsdfgsdfgsdfg</>
                ) : (
                  <Input
                    type="number"
                    name="cantidad"
                    className="form-control"
                    id="horizontal-colegiatura-Input"
                    placeholder={sCantidadaCargar}
                    //value={oUltimoCargo?.Cantidad ? oUltimoCargo.Cantidad : 0}
                    value={horizontalformik.values.colegiatura}
                    onChange={horizontalformik.handleChange}
                    onBlur={horizontalformik.handleBlur}
                    autocomplete="off"
                    data-1p-ignore
                    data-bwignore
                    data-lpignore="true"
                    invalid={
                      horizontalformik.touched.colegiatura &&
                      horizontalformik.errors.colegiatura
                        ? true
                        : false
                    }
                  />
                )}

                {horizontalformik.errors.colegiatura &&
                horizontalformik.touched.colegiatura ? (
                  <FormFeedback type="invalid">
                    {horizontalformik.errors.colegiatura}
                  </FormFeedback>
                ) : null}
              </Col>
            </Row>
            <Row className="mb-4">
              <Label
                htmlFor="horizontal-ultimacolegiatura-Input"
                className="col-sm-3 col-form-label"
              >
                Ultima Colegiatura
              </Label>
              <Col sm={9}>
                <Input
                  type="ultimacolegiatura"
                  name="ultimacolegiatura"
                  className="form-control"
                  id="horizontal-ultimacolegiatura-Input"
                  autoComplete="off"
                  placeholder={sFechaExpiracion}
                  value={horizontalformik.values.ultimacolegiatura}
                  onChange={horizontalformik.handleChange}
                  onBlur={horizontalformik.handleBlur}
                  invalid={
                    horizontalformik.touched.ultimacolegiatura &&
                    horizontalformik.errors.ultimacolegiatura
                      ? true
                      : false
                  }
                />
                {horizontalformik.errors.ultimacolegiatura &&
                horizontalformik.touched.ultimacolegiatura ? (
                  <FormFeedback type="invalid">
                    {horizontalformik.errors.ultimacolegiatura}
                  </FormFeedback>
                ) : null}
              </Col>
            </Row>

            <Row className="justify-content-end">
              <Col sm={9}>
                <div className="form-check mb-4">
                  <div>
                    {horizontalformik.errors.check &&
                    horizontalformik.touched.check ? (
                      <FormFeedback type="invalid">
                        {horizontalformik.errors.check}
                      </FormFeedback>
                    ) : null}
                  </div>
                </div>

                <div>
                  <Button type="submit" color="primary" className="w-md">
                    Cargar una Colegiatura
                  </Button>
                </div>
              </Col>
            </Row>
          </Form>
        </CardBody>
      </Card>
    </React.Fragment>
  )
}

export default CargosInsertColegiatura
